export const conferences = [
  {
    name: '11th International Conference on Smart and Sustainable Technologies (SpliTech 2026)',
    dates: '23–26 June 2026',
    location: 'Bol and Split, Croatia',
    talk: 'Probabilistic Multimodal Digital Twins for Healthcare Monitoring',
    format: 'Oral presentation',
    url: 'https://ieeexplore.ieee.org/document/11685578',
  },
  {
    name: '2nd International Conference on Federated Learning and Intelligent Computing Systems (FLICS 2026)',
    dates: '9–12 June 2026',
    location: 'Valencia, Spain',
    talk: 'Explainable Drug Effects on LDL Cholesterol in Cardiovascular Patients Using XGBoost with SHAP and Transformer Models',
    format: 'Oral presentation',
    url: 'https://ieeexplore.ieee.org/document/11621939',
  },
];
